export const MANUAL_REFRESH_COOLDOWN_MS = 900_000; // 15 minutes
export const AUTO_REFRESH_INTERVAL_MS = 1_800_000; // 30 minutes

export const MANUAL_REFRESH_STORAGE_KEY =
	"motokodollar.oracle.manualRefreshAt";

export function readLastManualRefreshAt(): number | null {
	try {
		const raw = localStorage.getItem(MANUAL_REFRESH_STORAGE_KEY);
		if (!raw) return null;
		const n = Number.parseInt(raw, 10);
		return Number.isFinite(n) ? n : null;
	} catch {
		return null;
	}
}

export function writeLastManualRefreshAt(at = Date.now()): void {
	try {
		localStorage.setItem(MANUAL_REFRESH_STORAGE_KEY, String(at));
	} catch {
		/* private mode */
	}
}

export function manualRefreshRemainingMs(
	lastAt: number | null,
	now = Date.now(),
): number {
	if (lastAt == null) return 0;
	const elapsed = now - lastAt;
	return Math.max(0, MANUAL_REFRESH_COOLDOWN_MS - elapsed);
}

export function formatCooldown(ms: number): string {
	const totalSec = Math.ceil(ms / 1000);
	const min = Math.floor(totalSec / 60);
	const sec = totalSec % 60;
	return `${min}:${sec.toString().padStart(2, "0")}`;
}
